module.exports = __webpack_public_path__ + "img/ic_mpe_time10_press.f23f16b3.png";